import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react'
import { MdOutlineWarning } from 'react-icons/md'
import { api } from '../../../../../../services/api'
import { useMutation } from 'react-query'

async function continuarMesmoAssim(data) {
  const res = await api.post('/site/v2/orcamento-crm/enviar-notificao-prazo-reduzido', data)

  return res.data
}

export const ConfirmDialog = ({ isOpen, onClose, onConfirm, estoqueAtual, data }) => {
  const cancelRef = null

  const { mutateAsync, isLoading, isError } = useMutation({
    mutationFn: (data) => continuarMesmoAssim(data),
    onSuccess: (data) => {
      console.log('Notificação enviada com sucesso:', data)
      onConfirm()
    },
    onError: (error) => {
      console.error('Erro ao enviar notificação:', error)
    },
  })

  async function handleConfirm() {
    //     - codigo_produto
    // - cor
    // - quantidade_produto
    // - prazo
    // - numero_nota
    // - nome_vendedor ``

    const dataFormatted = {
      ...data,
      codigo_produto: data.codigo_produto,
      cor: data.nome_cor.descricao_cor,
      prazo: data.prazo,
      quantidade_produto: data.quantidade_produto,
      numero_nota: data.numero_nota,
      nome_vendedor: data.nome_vendedor,
    }

    onConfirm()
    await mutateAsync(dataFormatted)
  }

  return (
    <AlertDialog size="xl" isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent display="flex" flexDirection="column" alignItems="center" justifyContent="center" w="100%" gap="20px">
          <AlertDialogHeader
            display="flex"
            alignItems="center"
            justifyContent="center"
            gridGap="10px"
            textTransform="uppercase"
            fontSize="26px"
            fontWeight="bold"
            textAlign="center"
            color="#FF0000"
          >
            <MdOutlineWarning size="34px" />
            Atenção!
          </AlertDialogHeader>

          <AlertDialogBody
            textAlign="center"
            fontSize="22px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gridGap="20px"
          >
            <Text>
              A quantidade selecionada{' '}
              <Text as="span" fontWeight="bold">
                excede o estoque disponível para o prazo Ultra Rápido.{' '}
              </Text>
            </Text>
            <Text>
              Estoque atual:{' '}
              <Text as="span" color="#FF0000" fontWeight="bold">
                {estoqueAtual}
              </Text>
            </Text>

            <Text fontSize="16px">Deseja continuar com o pedido mesmo assim?</Text>
          </AlertDialogBody>

          <AlertDialogFooter display="flex" justifyContent="center" gridGap="10px">
            <Button
              maxW="199px"
              fontWeight="semibold"
              color="white"
              fontSize="15px"
              w="full"
              borderRadius={0}
              bg={'#1976D2'}
              _hover={{ bg: '#1565C0', color: 'white' }}
              ref={cancelRef}
              onClick={onClose}
            >
              ajustar quantidade
            </Button>
            <Button
              onClick={handleConfirm}
              maxW="199px"
              fontWeight="semibold"
              color="black"
              fontSize="15px"
              w="full"
              borderRadius={0}
              _hover={{ bg: '#FFA200', color: 'white' }}
              bg={'#FFA200'}
            >
              continuar mesmo assim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
